export type ConcentrationUnit = 'M' | 'mM' | 'µM'
export type VolumeUnit = 'L' | 'mL' | 'µL'
export type TimeUnit = 'Hours' | 'Minutes' | 'Days'
export type MassUnit = 'ng' | 'pg'

const CONCENTRATION_TO_MOLAR: Record<ConcentrationUnit, number> = {
  M: 1,
  mM: 1e-3,
  'µM': 1e-6,
}

const VOLUME_TO_LITERS: Record<VolumeUnit, number> = {
  L: 1,
  mL: 1e-3,
  'µL': 1e-6,
}

const MASS_TO_NANOGRAMS: Record<MassUnit, number> = {
  ng: 1,
  pg: 1e-3,
}

export function concentrationToMolar(value: number, unit: ConcentrationUnit): number {
  return value * CONCENTRATION_TO_MOLAR[unit]
}

export function molarToConcentration(valueInMolar: number, unit: ConcentrationUnit): number {
  return valueInMolar / CONCENTRATION_TO_MOLAR[unit]
}

export function volumeToLiters(value: number, unit: VolumeUnit): number {
  return value * VOLUME_TO_LITERS[unit]
}

export function litersToVolume(valueInLiters: number, unit: VolumeUnit): number {
  return valueInLiters / VOLUME_TO_LITERS[unit]
}

export function massToNanograms(value: number, unit: MassUnit): number {
  return value * MASS_TO_NANOGRAMS[unit]
}

export function formatNumber(value: number, maxDecimals = 4): string {
  if (!Number.isFinite(value))
    return '—'
  if (Math.abs(value) !== 0 && (Math.abs(value) < 0.0001 || Math.abs(value) > 999999)) {
    return value.toExponential(4)
  }
  return Number(value.toFixed(maxDecimals)).toString()
}

export interface DoublingTimeResult {
  doublingTime: number
  growthRate: number
}

export function calculateDoublingTime(n0: number, nt: number, t: number): DoublingTimeResult {
  const lnRatio = Math.log(nt / n0)
  const doublingTime = (t * Math.log(2)) / lnRatio
  const growthRate = lnRatio / t
  return { doublingTime, growthRate }
}

export function calculateCopyNumber(massNg: number, lengthBp: number): number {
  return (massNg * 6.022e14) / (lengthBp * 650)
}
